module.exports = __webpack_public_path__ + "static/media/sheeba.93e7e6ce.jpg";